"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.delete.confirm.title': 'Delete Branch',
    'branch.delete.confirm.message': 'Are you sure you want to delete this branch?',
};
